// styles
import { themeOptions } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledGroupedTable = styled.div`
  .MuiPaper-root {
    box-shadow: none;
    border-radius: 0;
    border-top: 1px solid var(--color-pale-gray);
  }

  .MuiTableCell-head {
    height: 40px;
    padding: 11px 0;
    color: #222222;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
    background-color: var(--color-off-white);
  }

  .MuiTableCell-body {
    height: 40px;
    padding: 11px 0;
    color: ${themeOptions.palette.gray.dark};
    text-align: center !important;
  }

  .MuiTablePagination-root {
    border-bottom: none;
    padding: 0 !important;

    .MuiTablePagination-toolbar {
      padding: 0 !important;

      .MuiInputBase-root {
        margin-right: 0 !important;
        border-radius: 4px;
        border: 1px solid var(--color-pale-gray);
      }
    }
  }

  .MuiTablePagination-displayedRows {
    display: none;
  }

  .MuiTablePagination-actions {
    display: none;
  }

  .table-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }
`;

export const StyledGroupedTablePagination = styled.div`
  .MuiTablePagination-input {
    margin-left: 12px;
    padding: 0;

    .MuiTablePagination-select {
      padding: 6px 30px 6px 16px;
    }
  }

  .MuiPaginationItem-text.Mui-selected {
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-white);
    background-color: var(--color-primary-blue);
  }
`;
